export enum AuthenticationRequirement {
  Anonymous = 1,
  Optional = 2,
  Required = 3,
}
